"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _get = _interopRequireDefault(require("lodash/get"));

var _react = _interopRequireWildcard(require("react"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _Fieldset = _interopRequireDefault(require("./Fieldset"));

var _Option = _interopRequireDefault(require("./Option"));

var _Slider = _interopRequireDefault(require("./Slider"));

var _propTypes = require("./propTypes");

var _schema = _interopRequireDefault(require("./schema"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function Toggle(_ref) {
  var defaultSelected = _ref.defaultSelected,
      disabled = _ref.disabled,
      name = _ref.name,
      onChange = _ref.onChange,
      options = _ref.options,
      readOnly = _ref.readOnly,
      selected = _ref.selected,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["defaultSelected", "disabled", "name", "onChange", "options", "readOnly", "selected", "size"]);

  var _useState = (0, _react.useState)(selected || defaultSelected || (0, _get.default)(options, '0.id')),
      _useState2 = _slicedToArray(_useState, 2),
      selectedId = _useState2[0],
      setSelectedId = _useState2[1];

  (0, _react.useEffect)(function () {
    selected && !disabled && !readOnly && setSelectedId(selected);
  }, [selected, disabled, readOnly]);

  var toggleOption = function toggleOption() {
    var _ref2 = options.find(function (_ref3) {
      var id = _ref3.id;
      return id !== selectedId;
    }),
        newSelectedId = _ref2.id;

    if (!disabled && !readOnly) {
      !selected && setSelectedId(newSelectedId);
      onChange && onChange(newSelectedId);
    }
  };

  var onKeyDownHandler = function onKeyDownHandler(event) {
    if (['Enter', ' '].includes(event.key)) {
      event.preventDefault();
      toggleOption();
    }
  };

  return _react.default.createElement(_Fieldset.default, _extends({}, rest, {
    disabled: disabled,
    readOnly: readOnly,
    onClick: toggleOption,
    onKeyDown: onKeyDownHandler,
    size: size,
    tabIndex: 0,
    position: selectedId === (0, _get.default)(options, '0.id') ? 'left' : 'right'
  }), _react.default.createElement(_Flex.default, {
    alignItems: "center"
  }, options.map(function (option, index) {
    return _react.default.createElement(_react.Fragment, {
      key: option.id
    }, _react.default.createElement(_Option.default, _extends({}, option, {
      checked: option.id === selectedId,
      name: name,
      size: size
    })), index === 0 && _react.default.createElement(_Slider.default, {
      position: option.id === selectedId ? 'left' : 'right',
      size: size
    }));
  })));
}

Toggle.propTypes = _objectSpread({}, _schema.default.propTypes, {
  defaultSelected: _propTypes.optionIdValidator,
  options: _propTypes.optionsValidator.isRequired,
  selected: _propTypes.optionIdValidator
});
Toggle.defaultProps = {
  defaultSelected: undefined,
  selected: undefined,
  size: 'medium' // eslint-disable-line react/default-props-match-prop-types

};
var _default = Toggle;
exports.default = _default;